(function () {
  'use strict';

  var LANG = ((document.documentElement.lang || '').split('-')[0] || '').toLowerCase();
  if (!LANG || LANG === 'en') return;

  var POLL_MS = 100;
  var MAX_WAIT_MS = 15000;

  function waitFor(check, cb) {
    var start = Date.now();
    (function poll() {
      var v = check();
      if (v) return cb(v);
      if (Date.now() - start > MAX_WAIT_MS) return;
      setTimeout(poll, POLL_MS);
    })();
  }

  // Rivo uses a namespaced Alpine fork. Try common access paths and fall back
  // to introspecting a hydrated [rivo-x-data] element's data stack.
  function makeStoreGetter() {
    if (window.RivoAlpine && typeof window.RivoAlpine.store === 'function') {
      return function (n) { return window.RivoAlpine.store(n); };
    }
    if (window.Alpine && typeof window.Alpine.store === 'function') {
      return function (n) { return window.Alpine.store(n); };
    }
    var el = document.querySelector('[rivo-x-data]');
    var data = el && (
      (el._x_dataStack && el._x_dataStack[0]) ||
      (el.__x && el.__x.$data)
    );
    if (data && data.$store) {
      return function (n) { return data.$store[n]; };
    }
    return null;
  }

  function storeReady(getStore) {
    var rl = getStore('rivo_lp_translation');
    var loy = getStore('loy_config');
    var hasRl = rl && Object.keys(rl).length > 0;
    var hasLoy = loy && (
      (loy.ways_to_earn && loy.ways_to_earn.length) ||
      (loy.rewards && loy.rewards.length) ||
      (loy.vip_tiers && loy.vip_tiers.length)
    );
    return hasRl || hasLoy;
  }

  waitFor(
    function () { return window.MAKIA_TRANSLATIONS && window.MAKIA_TRANSLATIONS[LANG]; },
    function (T) {
      waitFor(
        function () {
          var g = makeStoreGetter();
          return g && storeReady(g) ? g : null;
        },
        function (getStore) { run(T, getStore); }
      );
    }
  );

  function run(T, getStore) {
    apply(T, getStore);

    // Rivo may populate or replace store entries late (customer fetch, etc.).
    // Re-apply on DOM changes so dynamic data items stay translated.
    var throttled = throttle(function () { apply(T, getStore); }, 200);
    var observer = new MutationObserver(throttled);
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  function apply(T, getStore) {
    overlayDict(getStore('rivo_lp_translation'), T.rivo_lp_translation);
    overlayDict(getStore('translations'), T.translations);
    patchLoyConfig(getStore('loy_config'), T);
    patchHardcoded(T['static'] || {});
  }

  function overlayDict(target, src) {
    if (!target || !src) return;
    Object.keys(src).forEach(function (k) {
      if (src[k] != null && src[k] !== '') target[k] = src[k];
    });
  }

  function patchLoyConfig(loy, T) {
    if (!loy) return;

    if (loy.ways_to_earn && T.earning_rules) {
      loy.ways_to_earn.forEach(function (item) {
        var tr = T.earning_rules[String(item.id)];
        if (!tr) return;
        if (tr.title) item.title = tr.title;
        if (tr.desc) item.desc = tr.desc;
      });
    }

    if (loy.rewards && T.rewards) {
      loy.rewards.forEach(function (item) {
        var tr = T.rewards[String(item.id)];
        if (!tr) return;
        if (tr.name) item.name = tr.name;
        if (tr.description) item.description = tr.description;
      });
    }

    var table = loy.loyalty_landing_page_settings && loy.loyalty_landing_page_settings.vip_tiers_table_data;
    if (table) {
      table.forEach(function (row) {
        if (T.perks && T.perks[row.perk]) row.perk = T.perks[row.perk];
        if (row.tiers && T.perk_values) {
          row.tiers.forEach(function (t) {
            if (T.perk_values[t.value]) t.value = T.perk_values[t.value];
          });
        }
      });
    }
  }

  // Strings hardcoded in the rendered Liquid blocks (no Rivo translation key).
  // Match by exact textContent inside a small set of selectors to avoid collisions.
  var HARDCODED_SELECTORS = [
    '.rivo-account-activity-block-header-title',
    '.rivo-account-activity-block-header-subtitle',
    '.rivo-account-rewards-progress-block-header-title',
    '.rivo-account-unused_rewards-block-header-title',
    '.rivo-account-unused_rewards-block-header-subtitle',
    '.rivo-account-vip-tier-block-header-title',
    '#points-logs-activity thead th',
    '#points-logs-activity tbody td'
  ].join(',');

  function patchHardcoded(dict) {
    if (!dict) return;
    var nodes = document.querySelectorAll(HARDCODED_SELECTORS);
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.children.length > 0) continue;
      if (el.hasAttribute('rivo-x-text') || el.hasAttribute('rivo-x-html')) continue;
      var txt = (el.textContent || '').trim();
      if (txt && dict[txt] && el.textContent.trim() !== dict[txt]) {
        el.textContent = dict[txt];
      }
    }
  }

  function throttle(fn, wait) {
    var pending = false;
    return function () {
      if (pending) return;
      pending = true;
      setTimeout(function () { pending = false; fn(); }, wait);
    };
  }
})();
